// Generated by purs version 0.13.5
"use strict";
var $foreign = require("./foreign.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Console = require("../Effect.Console/index.js");
var Items = require("../Items/index.js");
var React_Basic = require("../React.Basic/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var React_Basic_DOM_Events = require("../React.Basic.DOM.Events/index.js");
var React_Basic_DOM_Generated = require("../React.Basic.DOM.Generated/index.js");
var React_Basic_DOM_Internal = require("../React.Basic.DOM.Internal/index.js");
var component = React_Basic.createComponent("Menu");
var cleanupName = (function () {
    var $8 = Data_String_Common.replaceAll("-")(" ");
    var $9 = Data_String_Common.replaceAll("_")(" ");
    return function ($10) {
        return $8($9($10));
    };
})();
var sidenav = (function () {
    var render = function (self) {
        var mkNav = function (v) {
            return function (v1) {
                if (v1 instanceof Items.Category) {
                    return React_Basic_DOM_Generated.li()({
                        style: React_Basic_DOM.css({
                            marginLeft: Data_Show.show(Data_Show.showInt)(v * 10 | 0) + "px"
                        }),
                        children: Data_Array.cons(React_Basic_DOM_Generated.a()({
                            href: "#" + v1.value0.path,
                            className: "waves-effect sidenav-close",
                            style: React_Basic_DOM.css({
                                textTransform: "capitalize"
                            }),
                            children: [ React_Basic_DOM.text(cleanupName(v1.value0.label)) ],
                            onClick: React_Basic_DOM_Events.capture_(function __do() {
                                Effect_Console.log("onclick")();
                                return self.props.onClick(v1.value0.path)();
                            })
                        }))(Data_Array.cons(React_Basic_DOM_Generated.ul_(Data_Functor.map(Data_Functor.functorArray)(mkNav(v + 1 | 0))(v1.value0.items)))([  ]))
                    });
                };
                return Data_Monoid.mempty(React_Basic.monoidJSX);
            };
        };
        return React_Basic.fragment([ React_Basic_DOM_Generated.ul()({
            className: "sidenav",
            id: "slide-out",
            children: [ mkNav(0)(self.props.items) ]
        }), React_Basic.element(React_Basic_DOM_Internal.unsafeCreateDOMComponent("a"))({
            href: "#",
            "data-target": "slide-out",
            className: "sidenav-trigger",
            style: React_Basic_DOM.css({
                display: "inline"
            }),
            children: [ React_Basic_DOM_Generated.i()({
                className: "material-icons",
                children: [ React_Basic_DOM.text("menu") ]
            }) ]
        }) ]);
    };
    var didMount = function (self) {
        return Data_Functor["void"](Effect.functorEffect)($foreign.initSidenav);
    };
    return React_Basic.make()(component)({
        initialState: Data_Unit.unit,
        didMount: didMount,
        render: render
    });
})();
module.exports = {
    component: component,
    sidenav: sidenav,
    cleanupName: cleanupName,
    initSidenav: $foreign.initSidenav
};
